import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Col,
    Container,
    Form,
    InputGroup,
    Modal,
    Nav,
    Row,
    Tab,
    Table,
} from "react-bootstrap";
import { AiOutlineEdit } from "react-icons/ai";
import { GoCheckCircleFill, GoSearch } from "react-icons/go";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import Loader from "../Loader/Loader";
import NoDataFound from "../../assets/images/empty_item.svg";
import Pagination from "../Pagination/Pagination";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import {
    FileEarmarkArrowDown,
    FileEarmarkArrowUp,
} from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { RiCloseCircleFill } from "react-icons/ri";
import moment from "moment-timezone";

const OrdersRefund = () => {
    const [ordersRefund, setOrdersRefund] = useState<any[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [loader, setLoader] = useState(false);
    const [modalDeleteShow, setDeleteModalShow] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [status, setStatus] = useState("PENDING");
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [currentColum, setcurrentColum] = useState("created_at");
    const [currentSort, setcurrentSort] = useState("DESC");
    const menuList = useSelector((state: any) => state.profile.menus);
    const [modalAcceptShow, setModalAcceptShow] = useState(false);
    const [selectedCustomerSupport, setSelectedCustomerSupport] = useState<any>(null);
    const [acceptLoader, setAcceptLoader] = useState(false);
    const [modalRejectShow, setModalRejectShow] = useState(false);
    const [modalStatus, setModalStatus] = useState("");
    const [isShow, setModalShow] = useState(false);
    const [rejectLoader, setRejectLoader] = useState(false);
    const [modalLoader, setmodalLoader] = useState(false);
    const latestRequestRef = React.useRef(0);

    const supportMenu = menuList.find((menu: any) => menu.name === "Support");
    const customerSupportAccess = supportMenu?.child?.find(
        (child: any) => child.name === "Customer Supports"
    )?.access;

    useEffect(() => {
        fetchCustomerSupportes(page, keyword, status);
    }, [page, currentColum, currentSort, keyword]);

    const Search = (value: any) => {
        setPage(1);
        setIsSearchActive(true);
        fetchCustomerSupportes(1, value, status);
    }

    const fetchCustomerSupportes = (
        page: number,
        keyword?: string,
        status?: string
    ) => {
        setLoader(true);
        const requestId = ++latestRequestRef.current;
        const offset = page - 1;
        const body = {
            offset: offset.toString(),
            keyword: keyword || "",
            type: status || "",
            sort_by: currentColum || "",
            sort_order: currentSort || "",
            app_type: "CUSTOMER",
        };
        const queryParam = new URLSearchParams(body);
        WebService.getAPI({
            action: `refund-order?` + queryParam,
            body: null,
            isShowError: true,
        })
            .then((res: any) => {
                if (requestId !== latestRequestRef.current) return;
                setOrdersRefund(res.list);
                setTotalCount(res.count);
                setLoader(false);
            })
            .catch((error) => {
                if (requestId !== latestRequestRef.current) return;
                setLoader(false);
                console.error(error);
            });
    };

    const handleStatus = () => {
        if (!selectedCustomerSupport) return;
        const body = {
            order_id: selectedCustomerSupport.id,
            refund_amount: selectedCustomerSupport.refund_amount,
        };
        setmodalLoader(true);
        WebService.postAPI({
            action: `refund-order`,
            body: body,
            isShowError: true,
        })
            .then((res: any) => {
                setModalShow(false);
                setmodalLoader(false);
                fetchCustomerSupportes(page, keyword, status);
            })
            .catch((error) => {
                setmodalLoader(false);
                console.error(error);
            });
    };



    const sorting = (sort_by: any, colum_name: any) => {
        var sortBy = sort_by;
        if (currentColum !== colum_name) {
            sortBy = "DESC";
        } else {
            if (currentSort === "DESC") {
                sortBy = "ASC";
            } else {
                sortBy = "DESC";
            }
        }
        sort_by = sortBy;
        setcurrentSort(sortBy);
        setcurrentColum(colum_name);
    };

    const dynamicSortIcons = (column: string) => {
        const isActive = currentColum === column;

        return (
            <span style={{ marginLeft: "6px", color: isActive ? "#000" : "#ccc" }}>
                {isActive ? (
                    currentSort === "DESC" ? (
                        <FileEarmarkArrowDown size={14} />
                    ) : (
                        <FileEarmarkArrowUp size={14} />
                    )
                ) : (
                    <span style={{ display: "inline-block", transform: "rotate(90deg)" }}>
                        ↕
                    </span>
                )}
            </span>
        );
    };

    return (
        <>
            <Container className="page-container">
                <Row className="mb-3">
                    <Col>
                        <h4 className="mb-4 text-primary">
                            Refund Order List
                        </h4>
                    </Col>
                </Row>
                <Card className="card-style mb-3">
                    {customerSupportAccess && customerSupportAccess.can_read === "1" ? (
                        <>
                            <Card.Body>
                                <Row>
                                    <Col md={4}>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text id="basic-addon1">
                                                <GoSearch />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search"
                                                value={keyword}
                                                onChange={
                                                    (e) => {
                                                        setKeyword(e.target.value);
                                                        Search(e.target.value);
                                                    }}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Tab.Container
                                    id="left-tabs-example"
                                    defaultActiveKey="pending"
                                    onSelect={(key) => {
                                        setStatus(key?.toUpperCase() || ""); // Set the status based on the selected tab
                                        setPage(1); // Reset to the first page
                                        fetchCustomerSupportes(1, keyword, key?.toUpperCase() || ""); // Fetch data for the selected tab
                                    }}
                                >
                                    <Nav variant="underline" className="tab-style-underline">
                                        <Nav.Item>
                                            <Nav.Link eventKey="pending">Pending</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="inprogress">Inprogress</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="success">Success</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="pending">
                                            {/* <Row>
                                                <Col md={4}>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text id="basic-addon1">
                                                            <GoSearch />
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            placeholder="Search"
                                                            value={keyword}
                                                            onChange={(e) => {
                                                                setKeyword(e.target.value);
                                                                Search(e.target.value);
                                                            }}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handleSearch}
                                                        >
                                                            Search
                                                        </Button>
                                                        {isSearchActive && (
                                                            <Button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row> */}
                                            {!loader ? (
                                                <div className="border-radius table-responsive">
                                                    {ordersRefund.length > 0 ? (
                                                        <Table responsive="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                    >
                                                                        Order Id
                                                                    </th>
                                                                    <th
                                                                    >
                                                                        Refund Amount
                                                                    </th>
                                                                    <th
                                                                    >
                                                                        Placed At
                                                                    </th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ordersRefund.map((CustomerSupport) => (
                                                                    <tr key={CustomerSupport.id}>
                                                                        <td>
                                                                            {CustomerSupport?.id}
                                                                        </td>
                                                                        <td>{CustomerSupport?.refund_amount}</td>
                                                                        <td>
                                                                            {CustomerSupport?.placed_at
                                                                                ? moment
                                                                                    .utc(CustomerSupport?.placed_at)
                                                                                    .tz("Asia/Kolkata")
                                                                                    .format("DD MMM YYYY hh:mm A")
                                                                                : "-"}
                                                                        </td>
                                                                        <td>
                                                                            <Button
                                                                                className="btn btn-primary btn-sm me-1"
                                                                                onClick={() => {
                                                                                    setSelectedCustomerSupport(CustomerSupport);
                                                                                    setModalStatus("RESOLVED");
                                                                                    setModalShow(true);
                                                                                }}
                                                                                title="Refund"
                                                                            >
                                                                                Refund
                                                                            </Button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <div className="table-wrap position-relative text-center">
                                                            <div className="no-data-flound">
                                                                <div className="text-center">
                                                                    <img
                                                                        src={NoDataFound}
                                                                        alt=""
                                                                        width={110}
                                                                        className="mb-3"
                                                                    />
                                                                    <h3 className="text-secondary font-12">
                                                                        No Record Found
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {ordersRefund.length > 0 && (
                                                        <Pagination
                                                            pagination={10}
                                                            totalItems={totalCount}
                                                            changePage={(page: number) => setPage(page)}
                                                            changeCurrentPage={page}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <Loader show={loader} />
                                            )}
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="inprogress">
                                            {/* <Row>
                                                <Col md={4}>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text id="basic-addon1">
                                                            <GoSearch />
                                                        </InputGroup.Text>
                                                        <Form.Control
                                                            placeholder="Search"
                                                            value={keyword}
                                                            onChange={(e) => {
                                                                setKeyword(e.target.value);
                                                                Search(e.target.value);
                                                            }}
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={handleSearch}
                                                        >
                                                            Search
                                                        </Button>
                                                        {isSearchActive && (
                                                            <Button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                onClick={handleClearSearch}
                                                            >
                                                                Clear
                                                            </Button>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row> */}
                                            {!loader ? (
                                                <div className="border-radius table-responsive">
                                                    {ordersRefund.length > 0 ? (
                                                        <Table responsive="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th className="cursor-pointer"  >
                                                                        Order ID
                                                                    </th>
                                                                    <th className="cursor-pointer"  >
                                                                        Refund Amount
                                                                    </th>
                                                                    <th className="cursor-pointer"  >
                                                                        Placed At
                                                                    </th>
                                                                    <th className="cursor-pointer"  >
                                                                        Initiate At
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ordersRefund.map((order: any) => (
                                                                    <tr key={order.id}>
                                                                        <td>
                                                                            {order?.id}{" "}
                                                                        </td>
                                                                        <td>
                                                                            {order?.refund_amount}{" "}
                                                                        </td>
                                                                        <td> {order?.placed_at
                                                                            ? moment
                                                                                .utc(order?.placed_at)
                                                                                .tz("Asia/Kolkata")
                                                                                .format("DD MMM YYYY hh:mm A")
                                                                            : "-"}</td>
                                                                        <td> {order?.refund_payment?.created_at
                                                                            ? moment
                                                                                .utc(order?.refund_payment?.created_at)
                                                                                .tz("Asia/Kolkata")
                                                                                .format("DD MMM YYYY hh:mm A")
                                                                            : "-"}
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <div className="table-wrap position-relative text-center">
                                                            <div className="no-data-flound">
                                                                <div className="text-center">
                                                                    <img
                                                                        src={NoDataFound}
                                                                        alt=""
                                                                        width={110}
                                                                        className="mb-3"
                                                                    />
                                                                    <h3 className="text-secondary font-12">
                                                                        No Record Found
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {ordersRefund.length > 0 && (
                                                        <Pagination
                                                            pagination={10}
                                                            totalItems={totalCount}
                                                            changePage={(page: number) => setPage(page)}
                                                            changeCurrentPage={page}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <Loader show={loader} />
                                            )}
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="success">
                                            {!loader ? (
                                                <div className="border-radius table-responsive">
                                                    {ordersRefund.length > 0 ? (
                                                        <Table responsive="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th className="cursor-pointer">
                                                                        Order ID
                                                                    </th>
                                                                    <th className="cursor-pointer">
                                                                        Refund Amount
                                                                    </th>
                                                                    <th className="cursor-pointer">
                                                                        Placed At
                                                                    </th>
                                                                    <th className="cursor-pointer">
                                                                        Initiate At
                                                                    </th>
                                                                    <th className="cursor-pointer">
                                                                        Success At
                                                                    </th>
                                                                    <th className="cursor-pointer" >
                                                                        Refund Payment ID
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {ordersRefund.map((order: any) => (
                                                                    <tr key={order.id}>
                                                                        <td>
                                                                            {order?.id}{" "}
                                                                        </td>
                                                                        <td>
                                                                            {order?.refund_amount}{" "}
                                                                        </td>
                                                                        <td> {order?.placed_at
                                                                            ? moment
                                                                                .utc(order?.placed_at)
                                                                                .tz("Asia/Kolkata")
                                                                                .format("DD MMM YYYY hh:mm A")
                                                                            : "-"}
                                                                        </td>
                                                                        <td> {order?.refund_payment?.created_at
                                                                            ? moment
                                                                                .utc(order?.refund_payment?.created_at)
                                                                                .tz("Asia/Kolkata")
                                                                                .format("DD MMM YYYY hh:mm A")
                                                                            : "-"}
                                                                        </td>
                                                                        <td> {order?.refund_payment?.updated_at
                                                                            ? moment
                                                                                .utc(order?.refund_payment?.updated_at)
                                                                                .tz("Asia/Kolkata")
                                                                                .format("DD MMM YYYY hh:mm A")
                                                                            : "-"}
                                                                        </td>
                                                                        <td>
                                                                            {order?.refund_payment?.razorpay_refund_id}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <div className="table-wrap position-relative text-center">
                                                            <div className="no-data-flound">
                                                                <div className="text-center">
                                                                    <img
                                                                        src={NoDataFound}
                                                                        alt=""
                                                                        width={110}
                                                                        className="mb-3"
                                                                    />
                                                                    <h3 className="text-secondary font-12">
                                                                        No Record Found
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {ordersRefund.length > 0 && (
                                                        <Pagination
                                                            pagination={10}
                                                            totalItems={totalCount}
                                                            changePage={(page: number) => setPage(page)}
                                                            changeCurrentPage={page}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <Loader show={loader} />
                                            )}
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </Card.Body>
                        </>
                    ) : (
                        <>
                            {" "}
                            <div className="table-wrap position-relative text-center">
                                <div className="no-data-flound">
                                    <div className="text-center">
                                        <img src={NoDataFound} width={110} alt="" className="mb-3" />
                                        <h3 className="text-secondary font-12">
                                            Sorry, You don't have access
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Card>
            </Container>
            <Modal
                show={isShow}
                onHide={() => setModalShow(false)}
                animation={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Refund Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={12} sm={12} className="mb-3 text-center">
                            <GoCheckCircleFill size={100} style={{ color: "#28a745" }} />
                            <h6 className="font-18 pt-2">
                                Are you sure you want to refund this order?
                            </h6>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="px-3 pb-3">
                    <div className="d-flex justify-content-between align-items-center w-100 gap-3">
                        <Button
                            className="btn btn-outline-primary w-50"
                            onClick={() => setModalShow(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="btn-danger w-50"
                            onClick={handleStatus}
                            disabled={modalLoader}
                        >
                            {modalLoader ? "Refunding..." : "Refund"}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default OrdersRefund;
